import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import React, { FunctionComponent, ReactElement } from 'react'
import SmallBodyFont from '../../../../../Theme/Fonts/SmallBody'
import LeagueQualifierIndicator from '../../LeagueQualifierIndicator'
import Tendency from '../../Tendency'
import RowFont from '../../RowFont'
import InformationRowItem from '../../RowItem/InformationRowItem'
import MoreButton from '../../MoreButton'
import CompetitorImage from '../../CompetitorImage'
import AdditionalInfo from '../../AdditionalInfo'
import { BasicStandingRowProps } from '../../StandingsRowTypes'

type Props = BasicStandingRowProps

const Template: FunctionComponent<Props> = ({
    children,
    additionalInfoLabel,
    competitorLogoUrl,
    competitorName,
    competitorLogoAlt,
    hasDivider,
    imageType,
    leagueQualifierColor,
    onMorePress,
    onRowPress,
    rank,
    tendency,
    testID,
    isCompetitorBold,
}): ReactElement => (
    <Grid testID={testID}>
        <Touchable onPress={onRowPress} expand>
            <Grid
                backgroundColor="pearl"
                borderBottom={hasDivider ? '1px' : undefined}
                borderColor="tahitian-4"
                height={44}
                horizontal
                maxWidth="100%"
                paddingRight={4}
            >
                <LeagueQualifierIndicator color={leagueQualifierColor} />
                <InformationRowItem width={16}>
                    <RowFont bold>{rank}</RowFont>
                </InformationRowItem>
                <InformationRowItem width={8}>
                    <Tendency type={tendency} />
                </InformationRowItem>
                <CompetitorImage
                    imageUrl={competitorLogoUrl}
                    altText={competitorLogoAlt}
                    isFlag={imageType === 'FLAG'}
                />
                <Grid
                    centerVertical
                    minWidth={0}
                    horizontal
                    marginLeft={[2, 2, 3]}
                    marginRight={[0, 0, 4, 2]}
                >
                    <Grid minWidth={0} noExpand={!!additionalInfoLabel}>
                        <SmallBodyFont numberOfLines={1} bold={isCompetitorBold}>
                            {competitorName}
                        </SmallBodyFont>
                    </Grid>
                    <AdditionalInfo info={additionalInfoLabel} />
                </Grid>
                {children}
                <MoreButton
                    onMorePress={onMorePress}
                    testID={`standings-row-${competitorName}-more-icon`}
                />
            </Grid>
        </Touchable>
    </Grid>
)

export default Template
